import Customer from "../../../../utilities/data/model/Customer";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { compose } from "recompose";
import { withDatabase } from "@nozbe/watermelondb/DatabaseProvider";
import { Database } from "@nozbe/watermelondb";
import { View } from "react-native-ui-lib";
import {
  Card,
  TextButton,
  Text,
  Badge,
  Stack,
} from "@towersystems/roam-common-native";
import useOnline from "@towersystems/roam-common-native/lib/utilities/use-online";

interface CustomerCardProps
  extends ExtractedObservables<ReturnType<typeof getObserables>> {
  customerId: string;
  onEditCustomer?(customer: Customer): Promise<void> | void;
  wrapped?: boolean;
}

const getObserables = ({
  customerId,
  database,
}: {
  customerId: any;
  database: Database;
}) => ({
  customer: database.get<Customer>("customers").findAndObserve(customerId),
});

export const CustomerCardRenderer = ({
  customer,
  onEditCustomer,
  wrapped = true,
}: CustomerCardProps) => {
  const online = useOnline();

  const handleOnEditCustomer = () => {
    if (onEditCustomer) {
      onEditCustomer(customer);
    }
  };

  const badgeMarkup = customer.isRetailerCusAccount ? (
    <Badge retailerCustomerAccountStatus="RETAILER_CUSTOMER_ACCOUNT" />
  ) : null;

  /*
  const tradeCustomerBadgeMarkup = customer.isTradeCustomer ? (
    badgeMarkup ? (
      <Badge tradeCustomerStatus="TRADE_CUSTOMER" />
    ) : (
      <Badge tradeCustomerStatus="TRADE_CUSTOMER" />
    )
    */

  const cardContent = (
    <View flex row style={{ alignItems: "center" }}>
      <View flex>
        <Stack centerVertical spacing={3}>
          <Text variant="heading2">{`${customer.firstName} ${customer.lastName}`}</Text>
          {badgeMarkup}
        </Stack>
        {customer.emailAddress ? (
          <Text color="subdued">{`${customer.emailAddress}`}</Text>
        ) : undefined}
      </View>
      <View>
        {onEditCustomer ? (
          <TextButton disabled={!online} onPress={handleOnEditCustomer}>
            Edit
          </TextButton>
        ) : undefined}
      </View>
    </View>
  );

  return wrapped ? <Card title="Customer">{cardContent}</Card> : cardContent;
};

export const CustomerCard = compose<
  CustomerCardProps,
  {
    customerId: string;
    onEditCustomer?(customer: Customer): Promise<void> | void;
    wrapped?: boolean;
  }
>(
  withDatabase,
  withObservables(["customerId"], getObserables)
)(CustomerCardRenderer);
